import { useState, useEffect, useRef } from 'react';

// Define the type for the rectangle's properties
export interface ElementRect {
  x: number;
  y: number;
  top: number;
  left: number;
  bottom: number;
  right: number;
  height: number;
  width: number;
}
export const nullRect = {x: 0, y: 0, top: 0, left: 0, bottom: 0, right: 0, height: 0, width: 0 }
export function useElementRect(): [React.RefObject<HTMLDivElement>, ElementRect | null, () => void] {

// export function useElementRect(): [React.RefObject<HTMLDivElement>, ElementRect | null] {
  const ref = useRef<HTMLDivElement>(null);
  const [elementRect, setElementRect] = useState<ElementRect | null>(null);
  const updateRect = () => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setElementRect({
        x: rect.x,
        y: rect.y,
        top: rect.top,
        left: rect.left,
        bottom: rect.bottom,
        right: rect.right,
        height: rect.height,
        width: rect.width,
      });
    }
  };
  // useEffect(() => {
  //   console.log(elementRect)
  // }, [elementRect]);
  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      if (!entries || entries.length === 0) {
        return;
      }
      const { x, y, top, left, bottom, right, height, width } = entries[0].contentRect;
      setElementRect({ x, y, top, left, bottom, right, height, width });
    });

    if (ref.current) {
      resizeObserver.observe(ref.current);
    }
    updateRect(); // Initial measurement
    return () => resizeObserver.disconnect();
  }, []);

  return [ref, elementRect, updateRect]
  // // Return the ref and the element's rectangle
  // return [ref, elementRect];
}
